var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTextIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "b",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80.918,
    height: 31.287,
    viewBox: "0 0 80.918 31.287",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1947",
    "data-name": "Trac\\xE9 1947",
    d: "M60.2,16.233a10.272,10.272,0,0,0-.686-3.849,8.422,8.422,0,0,0-2.059-3.045,8.762,8.762,0,0,0-3.109-1.866,11.674,11.674,0,0,0-3.635-.59,11.46,11.46,0,0,0-3.442.525c-.107.032-.214.075-.322.118l-.643.236V2.916A2.984,2.984,0,0,0,43.258,0h-.011A2.99,2.99,0,0,0,40.32,2.938V28.348a2.967,2.967,0,0,0,.944,2.091,2.91,2.91,0,0,0,2.026.826h.086A2.99,2.99,0,0,0,46.3,28.327V18.045a7.583,7.583,0,0,1,.332-2.252,4.875,4.875,0,0,1,.868-1.651,3.9,3.9,0,0,1,1.308-1.029,4.317,4.317,0,0,1,1.758-.375h.139a5.263,5.263,0,0,1,1.533.236A2.548,2.548,0,0,1,53.9,14.507a4.913,4.913,0,0,1,.289,1.855V28.37a2.992,2.992,0,0,0,5.983-.021V16.233Z",
    transform: "translate(2.91)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1948",
    "data-name": "Trac\\xE9 1948",
    d: "M75.391,8.644A3.49,3.49,0,0,0,73.043,7.7H72.85a12.689,12.689,0,0,0-3.227.525,12.27,12.27,0,0,0-2.187.922l-.311.172-.247-.247a3.09,3.09,0,0,0-2.144-.879,3.017,3.017,0,0,0-3.024,2.938v16.64a3.02,3.02,0,0,0,3.013,2.938,3.031,3.031,0,0,0,3.013-2.948V20a9.148,9.148,0,0,1,.407-2.691,5.715,5.715,0,0,1,1.1-2.059,4.9,4.9,0,0,1,1.791-1.308,5.917,5.917,0,0,1,2.155-.407,4.94,4.94,0,0,1,.558.021h.118a2.686,2.686,0,0,0,1.791-.686,2.5,2.5,0,0,0,.8-1.823,3.265,3.265,0,0,0-1.061-2.4Z",
    transform: "translate(4.454 0.556)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1949",
    "data-name": "Trac\\xE9 1949",
    d: "M11.8,7.98a11.362,11.362,0,1,0-.064,22.709c6.69,0,11.815-4.986,11.815-11.354A11.366,11.366,0,0,0,11.8,7.98Zm-.064,4.739a6.405,6.405,0,0,1,6.326,6.615V19.4A6.272,6.272,0,0,1,11.8,25.95a6.366,6.366,0,0,1-6.294-6.615,6.328,6.328,0,0,1,6.229-6.615Z",
    transform: "translate(0 0.576)",
    fill: "#dadada"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_1950",
    "data-name": "Trac\\xE9 1950",
    d: "M37.156,8.433H32.782V3.2a2.986,2.986,0,0,0-5.972,0V8.433H24.976a2.916,2.916,0,1,0,0,5.833H26.81v14a2.986,2.986,0,0,0,5.972,0v-14h4.374a2.916,2.916,0,1,0,0-5.833Z",
    transform: "translate(1.592 0.016)",
    fill: "#dadada"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTextIcon);
export default __webpack_public_path__ + "static/media/textIcon.c3326cd30271da52e71f709c74f31d5b.svg";
export { ForwardRef as ReactComponent };